module.exports = {"130930100":"孟村镇","130930101":"新县镇","130930102":"辛店镇","130930103":"高寨镇","130930200":"宋庄子乡","130930201":"牛进庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130930.json
// module id = 311
// module chunks = 0